import { render, staticRenderFns } from "./RegrasTipoDiaSindicato.vue?vue&type=template&id=25defd31&scoped=true"
import script from "./RegrasTipoDiaSindicato.vue?vue&type=script&lang=js"
export * from "./RegrasTipoDiaSindicato.vue?vue&type=script&lang=js"
import style0 from "./RegrasTipoDiaSindicato.vue?vue&type=style&index=0&id=25defd31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25defd31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VSwitch,VTextField})
